<template>
  <v-card width="380" class="d-inline-block text-center pa-1" flat>
    <v-card :flat="$vuetify.breakpoint.mobile" class="mb-4 text-left">
      <v-form ref="form" @submit.prevent="signIn()" lazy-validation>
        <v-container class="pa-4">
          <v-row>
            <v-col class="text-h5">Sign in</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field label="Email address" v-model="email" outlined dense autofocus
                            validate-on-blur :rules="[required('email address'),emailRule]"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field label="Password" v-model="password" outlined dense
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        :error-messages="error"
                        validate-on-blur :rules="[required('password')]"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-btn color="primary" large width="100%" type="submit">Sign in</v-btn>
            </v-col>
          </v-row>
          <v-row dense class="text-center">
            <v-col>
              <v-btn text class="text-none" color="primary" small :to="{path:'/forgotPassword', query}">Forgot password?</v-btn>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-divider/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <google-sign-in :query="query" @googleIdToken="signIn($event)"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
    New to Purtrak? <v-btn text color="primary" :to="{path:'/createAccount',query}">Create account</v-btn>
  </v-card>
</template>

<script>
import axios from 'axios'
import GoogleSignIn from '@/components/GoogleSignIn'

export default {
  name: 'AuthorizePage',
  components: {GoogleSignIn},
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      required(label) {
        return value => !!value?.trim() || `Please enter your ${label}`
      },
      emailRule: v => {
        const pattern = /^((\s)*[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(\s*,\s*|\s*$))*$/i
        return !v || pattern.test(v) || `Your e-mail address doesn't look right`;
      },
      error: null

    }
  },
  computed: {
    query() {
      return this.$route.query;
    }
  },
  methods: {
    async signIn(googleIdToken) {
      if (!googleIdToken && !this.$refs.form.validate())
        return;

      this.error = null;

      const response = await axios.post('/_authorize', {googleIdToken, email:this.email, password:this.password, query:this.query});
      if (response.data.error) {
        if (response.data.error === 'invalid_credentials') {
          this.error = response.data.error_message;
          return;
        }
        if (response.data.redirect_uri)
          location.href = `${response.data.redirect_uri}/?error=${response.data.error}&error_message=${response.data.error_message}`;
        else
          this.$router.push({name:'Error',params:{error:response.data.error_message}});
      }
      else
        location.href = `${response.data.redirect_uri}/?code=${response.data.code}&state=${response.data.state}`;
    }
  }
}
</script>
